import React, { memo, ChangeEvent } from 'react'
import { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'
import { ICarrierCapacity } from 'apps/marketplace/store/contractLanes/types'
import { lookupCountryByStateCode } from 'utils/getLocations'
import { DAY_LIMITS, dayLimitsKey } from './CapacityDialog'
import { CapacityEntryForm } from './CapacityEntryForm'

interface CapacityEntryListProps {
  localCapacities: ICarrierCapacity[]
  setLocalCapacities: React.Dispatch<React.SetStateAction<ICarrierCapacity[]>>
  deleteCapacity: (uuid: string) => void
}

export const CapacityEntryList = memo<CapacityEntryListProps>(
  ({ deleteCapacity, localCapacities, setLocalCapacities }) => {
    const filteredLocalCapacities = localCapacities.filter(r => !r._destroy)
    return (
      <>
        {filteredLocalCapacities.map(limit => {
          const updateLocalLocation = (e: ILocationSuggestion) => {
            const countryCode = lookupCountryByStateCode(e.state)
            setLocalCapacities(
              localCapacities.map(capacity => {
                if (capacity.uuid === limit.uuid) {
                  capacity.pickupLocation = {
                    ...capacity.pickupLocation,
                    countryCode: countryCode ? countryCode.code : 'US',
                    city: e.city ?? '',
                    stateCode: e.state ?? '',
                  }
                }
                return capacity
              })
            )
          }
          const updateLocalRadius = ({ value }: { value: number }) => {
            setLocalCapacities(
              localCapacities.map(capacity => {
                if (capacity.uuid === limit.uuid) {
                  capacity.pickupLocation = {
                    ...capacity.pickupLocation,
                    radius: Number(value),
                  }
                }
                return capacity
              })
            )
          }
          const updateLocalDayLimit = ({
            target: { id: dayId, value },
          }: ChangeEvent<HTMLInputElement>) => {
            setLocalCapacities(
              localCapacities.map(capacity => {
                if (capacity.uuid === limit.uuid) {
                  const dayType = dayId.split(':')[1] as dayLimitsKey
                  capacity[DAY_LIMITS[dayType]] = value
                }
                return capacity
              })
            )
          }
          const deleteSelectedCapacity = () => {
            if (limit.uuid) deleteCapacity(limit.uuid)
          }
          return (
            <div key={limit.uuid}>
              <CapacityEntryForm
                capacity={limit}
                updateLocation={updateLocalLocation}
                updateRadius={updateLocalRadius}
                updateDayLimit={updateLocalDayLimit}
                deleteCapacity={deleteSelectedCapacity}
              />
              <hr />
            </div>
          )
        })}
      </>
    )
  }
)
